import { App } from "vue";
import CommonBreadcrumb from "@/components/common/CommonBreadcrumb.vue";

export default {
  install(app: App) {
    app.component("CommonBreadcrumb", CommonBreadcrumb);
  },
};
